export default __webpack_public_path__ + "6fc533b68643a20cd131dca5ec2e06ed.png";